import apiClient from './apiClient';
import { POST_EXCHANGE_RATE_URL } from './apiUrl';

const postExchangeRateApi = data => {
  return apiClient.post(POST_EXCHANGE_RATE_URL, data);
};

export default postExchangeRateApi;
